/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Meta from './Meta';

const propTypes = {
    page: AppPropTypes.page,
};

const defaultProps = {
    page: null,
};

function PageMeta({ page, ...props }) {
    const { handle, title, description, url } = page || {};
    return (
        <Meta
            title={handle !== 'home' ? title : null}
            url={url}
            description={description}
            {...props}
        />
    );
}

PageMeta.propTypes = propTypes;
PageMeta.defaultProps = defaultProps;

export default React.memo(PageMeta);
